import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themetwo/icon_search.png'
import _imports_1 from '@/assets/common/loadMore.png'


const _hoisted_1 = { class: "searchField" }
const _hoisted_2 = { class: "gameContainer" }
const _hoisted_3 = {
  key: 0,
  class: "gameProgressBar"
}
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = {
  key: 2,
  class: "loading_btn"
}

import { ref, computed, watch, inject } from 'vue';
import GameCard from '../../game/components/gameCard.vue';
import { debounce, fetchGameList, goToPlayGame } from '@/view/home/supportScript';
import { useRouter } from 'vue-router';
const PAGE_SIZE = 20

export default /*@__PURE__*/_defineComponent({
  __name: 'gamesearchPopup',
  emits: ['goToPlayGame'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}

const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)

const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value
}))
const emits = __emit
const closePopup = () => {
    show.value = false;
}

const loadMoreGame = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true

    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: number) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
const debouncedSearch = debounce(() => {
    resetList()
    getGameList()
}, 500)

watch(localValue, () => {
    debouncedSearch()
})
__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    onClickOverlay: closePopup,
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    position: "center",
    style: { height: '80%', zIndex: '10002' },
    class: "gamePopContainer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, { class: "popHeader" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "20",
            offset: "2",
            class: "Poptitle"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.allGames')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "cross",
                size: "16",
                onClick: closePopup
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_field, {
          modelValue: localValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
          type: "text",
          placeholder: _ctx.$t('home.searchGames'),
          class: "custom-field"
        }, {
          "left-icon": _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "left-section" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)
          ])),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_row, { class: "game_container" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "24",
              class: "right_container"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameSet.value?.gameList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_col, {
                        span: "6",
                        class: "game_item",
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createVNode(GameCard, {
                            gameImage: item.customIcon,
                            onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite,item.id)),
                            gameTypeId: item.id,
                            gameIsFavorite: item.isFavorite
                          }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                (gameSet.value?.gameList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: "progress",
                          style: _normalizeStyle({ width: gameSet.value?.gameList.length / gameSet.value.gameCount < 1 ? gameSet.value?.gameList.length * 100 / gameSet.value.gameCount + '%' : '100%' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "progress-end-dot",
                          style: _normalizeStyle({ left: `calc(${gameSet.value?.gameList.length * 100 / gameSet.value.gameCount}% - 6px)` })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round(gameSet.value?.gameList.length / gameSet.value.gameCount * 100)) + "% ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (!gameSet.value?.loading && gameSet.value?.showLoadMore)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "load_more_btn",
                      onClick: loadMoreGame
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.loadMore')) + " ", 1),
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        src: _imports_1,
                        alt: ""
                      }, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (gameSet.value?.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_van_loading, { size: "20" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})